import {
  GET_DAG_ERRORS,
  GET_DAG_FILTER,
  GET_DAG_FILTER_VALUE,
  GET_DAG_FILTER_VALUE_DYNAMIC_APPS,
  GET_DAG_FILTER_VALUE_USERS,
  GET_DAG_FILTERS,
  GET_MASTER_APPS,
  GET_DYNAMIC_APPS,
  SET_DAG_FILTER,
  SET_DAG_FILTER_VALUE_USER,
  SET_DAG_FILTER_VALUE,
  SET_DAG_LOADING,
  SET_DAG_MASTER_APP,
  RESET_DAG_STATE,
  GET_DAG_MASTER_APP,
  GET_DAG_DYNAMIC_APP,
} from '../actions/types'

const initialState = {
  masterApps: null,
  masterApp: null,
  dynamicApps: null,
  dynamicApp: null,
  filters: null,
  filter: null,
  filterValue: null,
  filterValueUsers: null,
  filterValueDynamicApps: null,
  errors: {},
  loading: true,
}

export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case GET_MASTER_APPS:
      return {
        ...state,
        loading: false,
        masterApps: payload,
        errors: {},
      }
    case GET_DYNAMIC_APPS:
      return {
        ...state,
        loading: false,
        dynamicApps: payload,
        errors: {},
      }
    case GET_DAG_DYNAMIC_APP:
      return {
        ...state,
        loading: false,
        dynamicApp: payload,
        errors: {},
      }
    case GET_DAG_FILTERS:
      return {
        ...state,
        loading: false,
        filters: payload,
        errors: {},
      }
    case GET_DAG_ERRORS:
      return {
        ...state,
        loading: false,
        errors: payload,
      }
    case SET_DAG_MASTER_APP:
    case GET_DAG_MASTER_APP:
      return {
        ...state,
        loading: false,
        masterApp: payload,
        errors: {},
      }
    case SET_DAG_FILTER:
    case GET_DAG_FILTER:
      return {
        ...state,
        loading: false,
        filter: payload,
        errors: {},
      }
    case GET_DAG_FILTER_VALUE:
    case SET_DAG_FILTER_VALUE:
      return {
        ...state,
        loading: false,
        filterValue: payload,
        errors: {},
      }
    case GET_DAG_FILTER_VALUE_USERS:
    case SET_DAG_FILTER_VALUE_USER:
      return {
        ...state,
        loading: false,
        errors: {},
        filterValueUsers: payload,
      }
    case RESET_DAG_STATE:
      return initialState
    case GET_DAG_FILTER_VALUE_DYNAMIC_APPS: {
      return {
        ...state,
        loading: false,
        errors: {},
        filterValueDynamicApps: payload,
      }
    }
    case SET_DAG_LOADING:
      return {
        ...state,
        errors: {},
        loading: true,
      }
    default:
      return state
  }
}
